import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";
import "../styles/Main.css";
import Linkedin from "../assets/companylogos/linkedin.svg";
import twitter from "../assets/companylogos/twitter-x.svg";
import facebook from "../assets/companylogos/facebook.svg";
import instagram from "../assets/companylogos/instagram.svg";

function FooterAccessibilityPageFooter() {
  return (
    <footer className="footer-background">
      <Container>
        <Row className="py-2">
          <Col sm={6} className="py-2 d-flex justify-content-center align-items-center">
            <span className="fs-5 me-1">©</span> {new Date().getFullYear()} TalentTracker
          </Col>
          <Col sm={6} className="text-center py-2 sm-text-end">
            <div>
              <a href="https://www.linkedin.com/" className="text-dark me-3">
                {/* <FaLinkedin size={30} /> */}
                <Image src={Linkedin} width="30px" height="30px" />
              </a>
              <a href="https://twitter.com/" className="text-dark me-3">
                {/* <FaTwitter size={30} /> */}
                <Image src={twitter} width="30px" height="30px" />
              </a>
              <a href="https://www.facebook.com/" className="text-dark me-3">
                {/* <FaFacebook size={30} /> */}
                <Image src={facebook} width="30px" height="30px" />
              </a>
              <a href="https://www.instagram.com/" className="text-dark me-3">
                {/* <FaInstagram size={30} /> */}
                <Image src={instagram} width="30px" height="30px" />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default FooterAccessibilityPageFooter;
